import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import logo from '../img/swb-logo.png';
import useAuth from '../hooks/useAuth';

function SubscriptionSuccess() {
    const navigate = useNavigate();
    const { auth } = useAuth();

    useEffect(() => {
        if (auth?.user) {
            const timer = setTimeout(() => {
                navigate('/', { replace: true, state: { showSubscriptionSuccess: true } });
            }, 3500);
            return () => clearTimeout(timer);
        }
    }, [auth, navigate]);

    if (!auth?.user) {
        return (
            <div className="flex items-center justify-center h-screen">
                <p>Verifying your secure session...</p>
            </div>
        );
    }

    return (
        <section className="w-screen h-screen py-16 bg-slate-50">
            <div className="main-bg">&nbsp;</div>
            <div className="flex items-center flex-col z-10 relative">
                <div className="flex">
                    <img src={logo} alt="Logo" className="w-72" />
                </div>

                <div
                    className="bg-white rounded-xl shadow-2xl py-10 mt-8 px-8 w-full flex flex-col items-center"
                    style={{ maxWidth: 600 }}
                >
                    {/* Success Icon */}
                    <div className="text-green-500 mb-6">
                        <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                    </div>

                    <h1 className="text-3xl text-[#41264B] font-bold text-center mb-4">
                        Membership Activated!
                    </h1>

                    <p className="text-gray-600 text-center mb-6">
                        Thank you for subscribing.
                    </p>

                    <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6 w-full">
                        <p className="text-green-800 text-center font-medium">
                            We are finalising your account details.
                        </p>
                    </div>

                    {/* Redirection indicator */}
                    <div className="text-center">
                        <p className="text-gray-500 text-sm mb-4">
                            Redirecting you in a few seconds...
                        </p>
                        <div className="flex items-center justify-center space-x-2">
                            <div className="animate-pulse h-2 w-2 bg-[#41264B] rounded-full"></div>
                            <div className="animate-pulse h-2 w-2 bg-[#41264B] rounded-full" style={{ animationDelay: '0.2s' }}></div>
                            <div className="animate-pulse h-2 w-2 bg-[#41264B] rounded-full" style={{ animationDelay: '0.4s' }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SubscriptionSuccess;